export class Credential {
    username: string;
    password: string;
    save?: boolean;
}
